import Vue from 'vue';
export default class Validators extends Vue {
    /**
     * Function to check if data is of String type.
     * @param {*} data Data to be checked
     */
    public isString(data: any): boolean {
        return typeof data.value === 'string';
    }
    /**
     * Function to check if data is of String type and not empty.
     * @param {*} data Data to be checked
     */
    public isNotEmptyString(data: any): boolean {
        return typeof data.value === 'string' && data.value.length > 0 && data.value !== '';
    }

    /**
     * Function to check if data contains non negative number.
     * @param {*} data Data to be checked (Can be of string type).
     */
    public isNonNegativeNumber(data: any): boolean {
        let val: any = null;
        if (typeof data.value === 'string') {
            val = Number(data.value);
        }

        return !(isNaN(val) || val < 0 || typeof data.value !== 'number' || data.value < 0);
    }

    /**
     * Function to check if data is of Number type and above zero.
     * @param {*} data Data to be checked
     */
    public isNumberAboveZero(data: any): boolean {
        return !(typeof data.value !== 'number' || data.value <= 0);
    }

    /**
     * Function to check if data is of TimeSpan type.
     * @param {*} data Data to be checked
     */
    public isTimeSpan(data: any): boolean {
        const matchResult = /(?:(\d+)\.)?(\d{1,2}):(\d{1,2}):(\d{1,2})/.exec(data.value);
        return !(!matchResult || matchResult.length !== 5);
    }
}
